<script>
    import { getContext } from 'svelte';
    import Number from './util/Number.svelte';

    export let dataKey;
    const {
        duration,
        distance,
        speed,
        missing_distance,
        enable_timeline,
        cars,
        car,
        poi_distance,
        save_poi,
        selector,
        showStops,
        showPOIs,
        export_values,
    } = getContext(dataKey);
    const selected_item = selector.selected_item;
</script>

<div class="col card">
    <span><b>Layers</b>:</span>
    <span>
        <label>
            <input type="checkbox" bind:checked={$showStops} /> Show stops
        </label>
    </span>
    <span>
        <label>
            <input type="checkbox" bind:checked={$showPOIs} /> Show POIs
        </label>
    </span>
    <span><b>Filters</b>:</span>
    <span>
        Duration highpass
        <Number
            bind:value={$duration}
            suffix="s"
            min="5"
            max="3600"
            sensitivity="0.5"
        />.
    </span>
    <span>
        Distance lowpass
        <Number
            bind:value={$distance}
            suffix="m"
            sensitivity="0.5"
            min="0"
            max="4000"
        />.
    </span>
    <span>
        Speed lowpass
        <Number
            bind:value={$speed}
            suffix="km/h"
            min="0"
            max="500"
            sensitivity="0.5"
        />.
    </span>

    <span><b>Classification</b>:</span>
    <span>
        Missing when traveled more than
        <Number
            bind:value={$missing_distance}
            suffix="m"
            min="0"
            max="4000"
            sensitivity="0.5"
        />.
    </span>
    <span><b>Detail</b>:</span>
    <span>
        <label>
            <input type="checkbox" bind:checked={$enable_timeline} /> Enable timeline
        </label>
    </span>
    <span>
        Car:
        <select bind:value={$car} disabled={!$enable_timeline}>
            {#each $cars as c}
                <option value={c}>
                    {c}
                </option>
            {/each}
        </select>
    </span>

    <span><b>Make POI</b>:</span>
    <span>
        Distance threshold
        <Number bind:value={$poi_distance} suffix="m" min="0" max="500" />
    </span>
    <span>
        <button on:click={save_poi} disabled={!$selected_item}>add POI</button>
        <button on:click={export_values} disabled="true">save to db</button>
    </span>
</div>

<style>
    button {
        width: 9ch;
        padding: 0;
    }
</style>
